"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberSchema = void 0;
exports.isNumberSchema = isNumberSchema;
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
/** returns true if the given schema is a NumberSchema */
function isNumberSchema(schema) {
    return schema.type === schema_type_1.SchemaType.Number || schema.type === schema_type_1.SchemaType.Integer;
}
class NumberSchema extends schema_1.PrimitiveSchema {
    constructor(name, description, type, precision, objectInitializer) {
        super(name, description, type);
        this.apply({ precision }, objectInitializer);
    }
}
exports.NumberSchema = NumberSchema;
//# sourceMappingURL=number.js.map